import * as React from 'react';
const { forwardRef } = React;
import CheckboxMUI, { CheckboxProps as CheckboxMUIProps } from '@material-ui/core/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';

import { useCustomTheme } from '../../styles';
import { Root } from './styled';


type CheckboxProps = {
	checked: boolean;
	label?: React.ReactNode;
	onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
} & Pick<CheckboxMUIProps,
	'disabled'
	| 'title'
	| 'tabIndex'
	| 'autoFocus'
	| 'id'
	| 'name'
	| 'inputProps'
	| 'ref'>
	& Pick<FormControlLabelProps, 'labelPlacement'>

const useStyles = makeStyles(t => {
	const [theme] = useCustomTheme(t);

	return {
		checkbox: {
			'&:not(.Mui-disabled).Mui-checked': {
				color: theme.color.accentPrimaryPressed
			}
		}
	}
})

const Checkbox: React.SFC<CheckboxProps> = forwardRef((props, ref) => {
	const {
		checked,
		label,
		labelPlacement,
		onChange,
		...rest
	} = props;
	const classess = useStyles({});
	const renderCheckboxBase = () => {
		return (
			<CheckboxMUI
				{...rest}
				ref={ref}
				color='primary'
				checked={checked}
				className={classess.checkbox}
				onChange={onChange}
			/>
		);
	};

	return (
		<Root>
			{
				Boolean(label)
				? <FormControlLabel
						control={renderCheckboxBase()}
						label={label}
						labelPlacement={labelPlacement}
					/>
				: renderCheckboxBase()
			}
		</Root>
	);
});

Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
	labelPlacement: 'end'
}

export default Checkbox;
